import React, { useEffect } from "react";
import Landing from "./Landing.jsx";
import About from "./About.jsx";

export default function Homepage() {
  useEffect(() => {
    document.title = "Casper De Bock · Software developer";
  }, []);

  return (
    <>
      <Landing />
      <div className="mt-24 desk:mt-32">
        <About />
      </div>
    </>
  );
}
